import * as Sentry from '@sentry/vue';
import { App, Plugin } from 'vue';

import { env } from '@/constants/env';

/**
 * @see https://docs.sentry.io/platforms/javascript/guides/vue/#vue-3---manual-initialization
 */
const SentryPlugin: Plugin = {
  install: (app: App) => {
    if (!env.VITE_SENTRY_ENABLED) {
      return;
    }

    Sentry.attachErrorHandler(app, {
      attachProps: true,
      trackComponents: true,
      timeout: 2000,
      hooks: ['activate', 'create', 'destroy', 'mount', 'update'],
      logErrors: false,
    });
  },
};

export default SentryPlugin;
